import Button from "components/common/Button"
import Score from "components/common/Score"
import { useHttpContext, useHttpUtil } from "context/HttpContext";
import Stats from "libs/utils/stats";
import Tools from "libs/utils/Tools";
import { useEffect, useState } from "react";
import { useDetailContext } from "../DetailContext"
import { ActionName, EventCallbackParamsType, MockupObject } from "../MockupEditor";
import CustomImage from "components/common/CustomImage";

export default function SaveArea(props: {}){
    const detailContext = useDetailContext();
    const httpUtil = useHttpUtil();
    const httpContent = useHttpContext();

    // 是否需要保存
    const [isSaveChange, setIsSaveChange] = useState<boolean>(false);
    // 正在保存...
    const [isSaving, setIsSaving] = useState<boolean>(false);

    // 下载参数
    const [downloadParameter, setDownloadParameter] = useState<DownloadParameter>({
        isAllowDownload: false,
        isShow : false,
        isDownloading : false,
        scale: 1,
        width: 0,
        oriWidth: 0,
        height: 0,
        oriHeight: 0
    });

    const beforeUploadEventHandler = (event: any) => {
        const confirmationMessage = 'Are you sure you want to leave this page? Unsaved changes will be lost.';
        if(isSaveChange){
            event.returnValue = confirmationMessage; 
            return confirmationMessage; // 兼容
        }  
    }

    useEffect(() => {
        window.addEventListener('beforeunload', beforeUploadEventHandler);
        return () => {
            window.removeEventListener('beforeunload', beforeUploadEventHandler);
        }
    },[isSaveChange])

    useEffect(() => {  
        disponseCallbackData();
    },[detailContext?.editorCallbackData])

    // 处理相关的回调
    const disponseCallbackData = async () => {
        const projectId = detailContext?.project.projectId as string;
        const type = detailContext?.editorCallbackData?.type ;
        switch(type){
            case EventCallbackParamsType.OBJECT_SELECT: // 对象选中
                if(detailContext?.editorCallbackData){
                    const data = detailContext?.editorCallbackData?.data as MockupObject ;
                    let width = data.mImageSrcWidth,
                        height = data.mImageSrcHeight;
                    if(data.parent){
                        width = data.parent.mImageSrcWidth;
                        height = data.parent.mImageSrcHeight ;
                    }
                    setDownloadParameter({...downloadParameter, width: width, height: height, oriWidth: width, oriHeight: height, isAllowDownload: true})
                }
                break;
            case EventCallbackParamsType.OBJECT_CANCEL_SELECT: // 取消选中
                setDownloadParameter({...downloadParameter, isAllowDownload: false, isShow: false})
                break;
            case EventCallbackParamsType.EDITOR_CHANGE: // 编辑器有数据变化
                setIsSaveChange(true);
                break;
            case EventCallbackParamsType.GET_EDITOR_DATA_CALLBACK: // 获取编辑器数据后的回调
                const resultData = detailContext?.editorCallbackData?.data ;
                const resData = await httpUtil.uploadProject({
                    projectId ,
                    content : resultData.data,
                    bytes: resultData.previewImage || null
                })
                setIsSaving(false);
                if(!resData.errCode){
                    setIsSaveChange(false);
                    httpContent?.response(0, 'Saved successfully')
                }else{
                    httpContent?.response(100, 'Save failed')
                }
                break;
            case EventCallbackParamsType.DOWNLOAD_CALLBACK: // 下载之后的回调
                const res = await httpUtil.post('/biz/images/build', {
                    fileType: downloadParameter.model || 'png',
                    width: downloadParameter.width,
                    height: downloadParameter.height,
                    scale: downloadParameter.scale,
                    projectId,
                    imageBase64 : detailContext?.editorCallbackData?.data
                })
                if(!res.errCode){
                    httpUtil.download(Tools.completeUrl(res.data), detailContext?.project.name);
                }else{
                    httpContent?.response(100, 'Download failed')
                }
                setDownloadParameter({...downloadParameter, isShow: false, isDownloading: false})
                break;
        }
    }

    const saveProjectData = () => {
        Stats.google('Save');
        setIsSaving(true);
        // 加一点延迟，在加载画布数据时，会造成浏览器卡导致保存加载进度未显示
        setTimeout(() => {
            detailContext?.triggerEditorAction({ name: ActionName.GET_EDITOR_DATA});
        },5)
    }
    
    const showDownload = () => {
        if(!detailContext?.checkedElementData){
            return httpContent?.response(100, 'Please select the image on the canvas to proceed with the operation.');
        }
        if(detailContext.checkedElementData.type == 3){
            return httpContent?.response(100, 'Please download the text after converting it into an image.');
        }
        downloadParameter && setDownloadParameter({...downloadParameter, isShow: !downloadParameter?.isShow})
    }

    // 下载
    const download = () => {
        Stats.google('Download');
        
        setDownloadParameter({...downloadParameter, isDownloading: true})
        setTimeout(() => {
            detailContext?.triggerEditorAction({
                name: ActionName.DOWNLOAD,
                params: detailContext?.project.name
            })
        },20);
    }

    const calcDownloadWH = (value: number, type:number = 0) => {
        if(type === 0){
            let scale = value ? value / downloadParameter.oriWidth  : 0;
            let width = value ;
            if(scale > 4){
                scale = 4 ;
                width = downloadParameter.oriWidth * scale ;
            }
            scale = parseFloat(scale.toFixed(6));
            const height = scale ? Math.ceil(downloadParameter.oriHeight * scale) : 0;
            setDownloadParameter({...downloadParameter, width, height, scale})
        }else{
            let scale = value ? value / downloadParameter.oriHeight : 0;
            let height = value ;
            if(scale > 4){
                scale = 4 ;
                height = downloadParameter.oriHeight * scale ;
            }
            scale = parseFloat(scale.toFixed(6));
            const width = scale ? Math.ceil(downloadParameter.oriWidth * scale) : 0;
            setDownloadParameter({...downloadParameter, width, height, scale})
        }
    }
    return (
        <Score>
            {
                <Button txt="Save" loadingTxt="Saving" disabled={!isSaveChange} rounded={10} clickEvent={saveProjectData} isLoading={isSaving} />
            }
            {
                // (downloadParameter && downloadParameter.isAllowDownload || guideContext?.isStartGuide) &&
                <div id="step5_element" className="relative flex items-center rounded-[10px] bg-[#14A5FA] text-[#FFFFFF] px-[20px] gap-[5px] cursor-pointer"
                    onClick={showDownload}>
                    <CustomImage src="/icon/icon-editor-download.png" className="w-[19px] xl:w-[21px]" />
                    <span className="text-[12px] xl:text-[14px]">Download</span>

                    {
                        downloadParameter.isShow && 
                        <div className="absolute flex flex-col w-[260px] p-[15px] bg-[#FFFFFF] right-0 top-[48px] z-[10009] text-[#000000] text-[14px] gap-[15px] shadow-xl rounded-[10px]"
                            onClick={(e) => e.stopPropagation()}>
                            <p className="text-[16px] font-bold">Download Options</p>
                            <span className="">File Type</span>
                            <select className="border rounded-[5px] py-[11px] pl-[15px] pr-[9px] outline-none" value={downloadParameter.model}
                                onChange={(e) => {setDownloadParameter({...downloadParameter, model: e.target.value})}}>
                                <option value="png">PNG</option>
                                <option value="jpg">JPG</option>
                            </select>
                            <div className="flex items-center gap-[10px]">
                                <span>Width:</span><input type="number" disabled value={downloadParameter.width} className="outline-none text-[12px] border rounded-[5px] p-[10px] w-[58px] text-center "
                                    onChange={(e) => {calcDownloadWH(+e.target.value)}}/>
                                <span>Height:</span><input type="number" disabled value={downloadParameter.height} className="outline-none text-[12px] border rounded-[5px] p-[10px] w-[58px] text-center"
                                    onChange={(e) => {calcDownloadWH(+e.target.value, 1)}}/>
                            </div>
                            <Button txt="Download" className="w-full py-[11px] justify-center" rounded={10} 
                                clickEvent={() => download()} isLoading={downloadParameter.isDownloading}></Button>
                        </div>
                    }
                </div>
            }
            
        </Score>
    )
}



type DownloadParameter = {
    isAllowDownload: boolean,
    isShow : boolean,
    isDownloading: boolean,
    model ?: string,
    scale : number,
    oriWidth : number,
    oriHeight : number,
    width : number,
    height : number
}